import React from 'react';
import { Icon } from '@/components/global/Icons';
import type { CatalogItem, FeatureList } from '@jucy/rentals-api-client/dist/rentals-api-v3';
import { IMotorhomeTabs } from '../MotorhomeDetails';

export const MotorhomeFeaturesTabPanel = ({ tab }: { tab: IMotorhomeTabs }) => {
    if (!tab?.items) {
        return;
    }
    return (
        <div id={tab.name} title={tab.title}>
            {tab.items.map((feature: FeatureList) => (
                <div key={feature.title} className="mb-16">
                    <h5 className="mb-6 capitalize">{feature.title}</h5>
                    <div className="grid gap-0 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                        {feature.items?.map((item: CatalogItem[string], index) => {
                            return (
                                <li key={index} className="mb-4 list-none flex items-center">
                                    <Icon id="tick" className="w-6 h-6 fill-primary mr-2" />
                                    {item}
                                </li>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};
